import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { NavbarComponent } from './shared/components/navbar/navbar.component';
import { MemberLayoutComponent } from './containers/member-layout/member-layout.component';
import { HttpClientModule } from '@angular/common/http';
import { DefaultLayoutComponent } from './containers/default-layout/default-layout.component';
import { HomeComponent } from './pages/home/home.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from './shared/shared.module';
import { GoogleMapsModule } from '@angular/google-maps';
import { ChartsModule } from 'ng2-charts';
import { StateListComponent } from './pages/state-list/state-list.component';
import { SwiperModule } from 'swiper/angular';
import { WeatherComponent } from './pages/weather/weather.component';
import SwiperCore, {
    Navigation,
    Pagination,
    Scrollbar,
    Autoplay,
    A11y,
  } from 'swiper/core';
import { PlantListComponent } from './pages/plant-list/plant-list.component';
import { EnvironmentalComponent } from './pages/environmental/environmental.component';
import { YieldGuaranteeComponent } from './pages/yield-guarantee/yield-guarantee.component';
import { AgmCoreModule } from '@agm/core';

  // install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, Autoplay]);
@NgModule({
    declarations: [
        AppComponent,
        NavbarComponent,
        MemberLayoutComponent,
        DefaultLayoutComponent,
        HomeComponent,
        StateListComponent,
        WeatherComponent,
        PlantListComponent,
        EnvironmentalComponent,
        YieldGuaranteeComponent,
    ],
    imports: [
        BrowserAnimationsModule,
        NgbModule,
        RouterModule,
        AppRoutingModule,
        HttpClientModule,
        MatDialogModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        GoogleMapsModule,
        ChartsModule,
        SwiperModule,
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }
